import { useSetRecoilState } from "recoil"
import styled from "styled-components"
import signupStepState from "../../../recoil/signupStep/atom"
import { toast } from "react-toastify"
import { useState } from "react"
import { useFormContext } from "react-hook-form"
import { StyledButton } from "../../common/Buttons"
import PhoneNumberInput from "./PhoneNumberInput"
import VerificationCodeInput from "./VerificationCodeInput"
import PositionDropdown from "./PositionDropdown"
import SchoolInfoInput from "./SchoolInfoInput"
import AdvertisementDropdown from "./AdvertisementDropdown"

const SecondInputGroup = () => {
  const setSignupStep = useSetRecoilState(signupStepState)
  const [isVerificationRequested, setIsVerificationRequested] =
    useState<boolean>(false)

  const { trigger, watch } = useFormContext()

  const goToNextStep = () => {
    trigger(
      ["phoneNumber", "isPhoneNumberVerified", "position", "advertisement"],
      { shouldFocus: true }
    ).then((isValidated) => {
      if (isValidated) {
        setSignupStep(3)
      } else {
        toast.error("가입 정보를 정확히 입력해주세요.")
      }
    })
  }

  return (
    <>
      <InputBox>
        <PhoneNumberInput
          setIsVerificationRequested={setIsVerificationRequested}
        />
        {isVerificationRequested && <VerificationCodeInput />}
        <PositionDropdown />
        {["중학생", "고등학생", "교사"].includes(watch("position")) && (
          <SchoolInfoInput />
        )}
        <AdvertisementDropdown />
      </InputBox>
      <NavigationButtonBox>
        <StyledButton $size="large" onClick={() => setSignupStep(1)}>
          이전
        </StyledButton>
        <StyledButton $size="large" onClick={goToNextStep}>
          다음
        </StyledButton>
      </NavigationButtonBox>
    </>
  )
}

export default SecondInputGroup

const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`

const NavigationButtonBox = styled.div`
  display: flex;
  gap: 10px;
`
